// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-rich-text[data-v-57e1b667] {\n  width: 100%;\n}\n.c-rich-text[data-v-57e1b667] ol,\n.c-rich-text[data-v-57e1b667] ul {\n  margin-bottom: 16px;\n}\n.c-rich-text[data-v-57e1b667] ol {\n  margin-left: 12px; /* for Safari */\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
